import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { TabNames } from '../../../../../../../../constants/tabMenuTypes';
import { hideTray, showTray } from '../../../../../../../../redux/modules/tray';
import colors from '../../../../../../../../styles/theme/foundation/colors';
import RequirementTemplateBlueprintType from '../../../../../../../../types/RequirementTemplateBlueprintType';
import { get } from '../../../../../../../../utils/arrayUtil';
import LoadingSpinner from '../../../../../../../Spinner';
import CreateCustomLanguageTray
  from '../../../../../RequirementTemplateRightBox/components/RequirementTemplateBuilderBodyRight/components/TemplateBuilderLanguagePanel/components/CreateCustomLanguageTray';
import TemplateBlockFooter from '../TemplateBlockFooter';

const InsuranceLanguageTemplateBlock = ({ templateBlock, blueprint }) => {
  const dispatch = useDispatch();

  const languageDescription = useMemo(() => {
    const language = get(templateBlock, 'requirementTemplateBlockProperties.0.requirement.language', '');

    if (language) {
      if (language.length > 250) {
        return `${language.substring(0, 249)}...`;
      }

      return language;
    }

    return '';
  }, [templateBlock]);

  const onRequiredToggle = isChecked => {
    templateBlock.required = isChecked;
    dispatch(blueprint.updateRequirementTemplateBlock(templateBlock.id, templateBlock));
  };

  const onBlockDelete = () => {
    dispatch(blueprint.deleteRequirementTemplateBlock(templateBlock.id));
  };

  const showLanguageTray = async () => {
    const languageId = get(templateBlock, 'requirementTemplateBlockProperties.0.requirement.id', null);
    dispatch(blueprint.setCurrentRequirementTemplateBlock(templateBlock.id));
    dispatch(blueprint.setCreateCustomStep(2, TabNames.Language));
    dispatch(blueprint.setEditCustomLanguageId(languageId));
    await dispatch(blueprint.listDeletedInsuranceLanguages());

    dispatch(showTray(
      () => <CreateCustomLanguageTray blueprint={blueprint} />,
      {
        onClose: () => {
          dispatch(hideTray());
          dispatch(blueprint.setEditCustomLanguageId(null));
          dispatch(blueprint.setCreateCustomStep(1, TabNames.Language));
          dispatch(blueprint.resetCurrentRequirementTemplateBlock());
          dispatch(blueprint.resetCreateCustomLanguage());
        }
      }
    ));
  };

  if (templateBlock) {
    return (
      <Box
        _hover={{ boxShadow: 'hover2' }}
        bgColor={colors.greyScale['100']}
        borderRadius="10px"
        boxShadow="sharp4"
        flexBasis="100%"
        layerStyle="panel"
        maxH="35vh"
        mb={4}
        minH="100px"
        minW="480px"
        mr={4}
        mt={1}
        textAlign="left"
        w="100%"
      >
        { templateBlock?.requirementTemplateBlockProperties.length > 0 && (
          <Flex
            borderBottom={`{1px solid ${colors.greyScale['200']}`}
            direction="column"
            justifyContent="flex-start"
            mb={2}
            mt={2}
            w="100%"
          >
            <Box pt={6} px={6} onClick={showLanguageTray}>
              <Box color={colors.greyScale['900']} overflowWrap="anywhere" textStyle="bodyMd600">
                {
                get(templateBlock, 'requirementTemplateBlockProperties.0.requirement.displayName', '')
              }
              </Box>
              <Box color={colors.greyScale['700']} mt={3} overflowWrap="anywhere" textAlign="left" textStyle="bodySm">
                { languageDescription }
              </Box>
            </Box>
            <TemplateBlockFooter
              borderColor={colors.background.secondaryArchived}
              isChecked={templateBlock?.required && templateBlock.required > 0}
              onChange={onRequiredToggle}
              onDelete={onBlockDelete}
            />
          </Flex>
        )}
        { !get(templateBlock, 'requirementTemplateBlockProperties.0.requirement.displayName', '')
        && (
          <Box mt={8}>
            <Text color={colors.greyScale['500']} fontSize="11px" textAlign="left">
              { get(templateBlock, 'requirementTemplateBlockProperties.0.requirement.description', '')}
            </Text>
            <LoadingSpinner isInline />
          </Box>
        )}
      </Box>
    );
  }

  return null;
};

InsuranceLanguageTemplateBlock.propTypes = {
  blueprint: RequirementTemplateBlueprintType,
  templateBlock: PropTypes.shape({
    required: PropTypes.bool,
    requirementTemplateBlockProperties: PropTypes.arrayOf(PropTypes.shape({}))
  })
};

export default InsuranceLanguageTemplateBlock;
